const addToggleClick = () => {
  const footerToggles = document.querySelectorAll( '.site-footer__toggle' );

  if (!footerToggles) {
    return;
  }

  [...footerToggles].forEach( (toggle) => {
    toggle.addEventListener( 'click', (e) => {
      const foldout = e.target.nextElementSibling;
      if (!foldout) {
        return;
      }
      foldout.classList.toggle( 'open' );
      foldout.setAttribute( 'aria-hidden', !foldout.classList.contains( 'open' ) );
      toggle.setAttribute( 'aria-expanded', foldout.classList.contains( 'open' ) );
    } );
  } );
}

const maybeAddAriaToFoldouts = () => {
  const foldouts = document.querySelectorAll( '.site-footer__foldout' );

  if (!foldouts) {
    return;
  }

  [...foldouts].forEach( (foldout) => {
    const isVisible = foldout.offsetHeight > 0 && foldout.offsetWidth > 0;

    if (!isVisible) {
      const randomId = Math.random().toString( 36 ).substring( 2, 9 );
      const toggle = foldout.previousElementSibling;

      if (toggle) {
        toggle.setAttribute( 'id', 'footer-toggle-' + randomId );
        toggle.setAttribute( 'aria-controls', 'footer-foldout-' + randomId );
        toggle.setAttribute( 'aria-expanded', false );
      }

      foldout.setAttribute( 'role', 'region' );
      foldout.setAttribute( 'id', 'footer-foldout-' + randomId );
      foldout.setAttribute( 'aria-labelledby', 'footer-toggle-' + randomId );
      foldout.setAttribute( 'aria-hidden', true );
    }
  } );
}

const footer = () => {
  maybeAddAriaToFoldouts();
  addToggleClick();
};

export default footer;
